import SchoolInsightsPanel from '../../components/SchoolInsightsPanel';

export default function SchoolDashboard() {
  return (
    <div className="p-6 lg:p-8 max-w-7xl mx-auto" data-testid="school-dashboard">
      <SchoolInsightsPanel showHeader />
    </div>
  );
}
